import { ITranslationConfig } from "../translation.config";

export class DigitalRetailingTranslationConfig implements ITranslationConfig {
    public metrics: any;
    public labels: any;
    public reportTitles: any;
    public chartDimensions: any;
}
